// src/app/modules/auth/models/auth.model.ts
export class AuthModel {
  authToken: string;
  refreshToken: string;
  expiresIn: Date;

  // New fields from your backend response
  userId!: number;
  customerId!: number | null;

  // Additional fields from the new API response format
  tenant_id?: number;
  customer_id?: number;
  mfa_enroll_advised?: boolean;
  mfa_verify_required?: boolean;
  mfa_required?: boolean;
  mfa_enroll_required?: boolean;
  mfa_pending?: boolean;
  mfa_last?: string;
  /** True when login succeeded but a customer/tenant context must still be chosen. */
  context_pending?: boolean;
  available_contexts?: Array<{
    tenant_id: number;
    tenant_name?: string | null;
    customer_id: number;
    customer_name?: string | null;
  }>;
  /** Minimal user from login/passkey response — avoids an immediate /auth/contact round-trip. */
  user?: {
    id: number;
    email?: string;
    username?: string;
    language?: string;
  };

  setAuth(auth: AuthModel) {
    this.authToken    = auth.authToken;
    this.refreshToken = auth.refreshToken;
    this.expiresIn    = auth.expiresIn;
    this.userId       = auth.userId;
    this.customerId   = auth.customerId;
    this.tenant_id    = auth.tenant_id;
    this.customer_id  = auth.customer_id;
    this.mfa_enroll_advised = auth.mfa_enroll_advised;
    this.mfa_verify_required = auth.mfa_verify_required;
    this.mfa_required = auth.mfa_required;
    this.mfa_enroll_required = auth.mfa_enroll_required;
    this.mfa_pending = auth.mfa_pending;
    this.mfa_last = auth.mfa_last;
    this.context_pending = auth.context_pending;
    this.available_contexts = auth.available_contexts;
    this.user = auth.user;
  }
}
